import { BrowserOptions } from '@sentry/react';
import { redactSensitiveData } from './redactSensitiveData';

export const beforeSend: NonNullable<BrowserOptions['beforeSend']> = (
  event,
  _hint,
) => {
  return redactSensitiveData(event);
};
